import loginClient from '../../client/loginClient';
import useClient from '../../client/userClient';
import funClient from '../../client/funClient';
export default class Model {
    public resultData = null;
    public ajaxLoginData = null;

    

    public async getData(params: any) {
        const result = await loginClient.getData(params);
        if (result && result.success) {
            this.resultData = result;
        }
    }
    public async ajaxLogin(params: any) {
        const result = await loginClient.ajaxLogin(params);
        if (result && result.success) {
            this.ajaxLoginData = result;
        }
    }
    public async add(params: any) {
        const result = await loginClient.add(params);
        if (result) {
            return result;
        }
    }

    //-----------------用户方法---------------
    public async selectPageData(params: any) {
        const result = await useClient.selectPageData(params);
        if (result) {
            return result;
        }
    }

    public async save(params: any) {
        const result = await useClient.save(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async removeByIds(params: any) {
        const result = await useClient.removeByIds(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async updateById(params: any) {
        const result = await useClient.updateById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }
    
    public async getById(params: any) {
        const result = await useClient.getById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    //---------------------功能创建，方法--------------------------
    public async count(params: any) {
        const result = await funClient.count(params);
        if (result) {
            return result;
        }
    }
}
